// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"595":"0cf8139a","855":"ce4ff273"}[chunkId] + ".chunk.js";
};